import { useState } from 'react';
import { useClassesTable } from '../../../../../components/Classes/hooks/useClassesTable';
import { ClassesModal } from '../../../../../components/Classes/Modals/ClassesModal';
import { InheritClassesModal } from '../../../../../components/Classes/Modals/InheritClassesModal';
import { DeputateClassesTable } from '../../../../../components/Classes/Tables/DeputateClassesTable';
import { useDeleteClasses } from '../../../../../hooks/useDeleteClasses';
import { usePermissionChecker } from '../../../../../hooks/usePermissionChecker';
import { showSuccessDeleteToast, showUserDbErrorToast } from '../../../../../utils/toast';

export const DeputateClassesContent = () => {
  const permissions = usePermissionChecker();
  const { deleteClass } = useDeleteClasses();

  const { DeleteDialog, confirmDelete } = useClassesTable();

  const [classesModalOpen, setClassesModalOpen] = useState<boolean>(false);
  const [inheritModalOpen, setInheritModalOpen] = useState<boolean>(false);
  const [classUuid, setClassUuid] = useState<null | string>(null);
  const [loading, setLoading] = useState<boolean>(false);

  function handleAdd() {
    setClassUuid(null);
    setClassesModalOpen(true);
  }

  function handleEdit(uuid: string) {
    setClassUuid(uuid);
    setClassesModalOpen(true);
  }

  function handleInherit(open: boolean) {
    setInheritModalOpen(open);
  }

  function handleClose() {
    setClassUuid(null);
    setClassesModalOpen(false);
  }

  async function handleDelete(uuid: string) {
    const confirmResult = await confirmDelete();
    setLoading(true);
    if (confirmResult) {
      const { error } = await deleteClass(uuid);
      if (error) {
        showUserDbErrorToast();
      } else {
        showSuccessDeleteToast();
      }
    }
    setLoading(false);
  }

  return (
    <>
      <DeputateClassesTable
        loading={loading}
        onAdd={() => handleAdd()}
        onEdit={(uuid) => handleEdit(uuid)}
        onInherit={() => handleInherit(true)}
        onDelete={(uuid) => handleDelete(uuid)}
        readonly={!permissions?.canWriteDeputate()}
      />

      <ClassesModal classUuid={classUuid} isOpen={classesModalOpen} onClose={() => handleClose()} />

      <InheritClassesModal isOpen={inheritModalOpen} onClose={() => handleInherit(false)} />

      <DeleteDialog />
    </>
  );
};
